import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { Link, NavLink } from 'react-router-dom';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import BreadcrumbsWrapper from '../../../components/breadcrumbs'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import { useContext, useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import Switch from '@mui/material/Switch';
import { checkPermission } from '../../../utils/checkPermissions';
import { Typography } from '@mui/material';



// Redux imports (optional, if you want to store in redux)
// import { useDispatch } from 'react-redux';
// import { setBranches } from '../../redux/slices/branchSlice';

export default function ApiKeys() {
  const [apiKeyList, setApiKeyList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [searchName, setSearchName] = useState('');
  const authCtx = useContext(AuthContext);
  const userPermissions = authCtx.permissions;
  
  // Check permissions
  const canCreateAPIKeys = checkPermission(userPermissions, 'api', 'create_api_keys');
  const canDisableAPIKeys = checkPermission(userPermissions, 'api', 'disable_api_keys');

  // Debounce ref
  const debounceRef = useRef();
  const dispatch = useDispatch();

  // Fetch branches API
 const fetchApiKeys = async (searchNameVal, pageVal = page) => {
  setLoading(true);
  try 
    {
    const payload = {
      page: pageVal,
      limit: 5,
      search: searchNameVal,
    };

    const response = await postRequest('private/apikeyList', payload, authCtx.token);
    console.log(response , 'response@123')
    if (response?.status === 200 && response?.data) {
      setApiKeyList(response.data.docs || []);
      setTotalPages(response.data.totalPages || 1);
      setTotalDocs(response.data.totalDocs || 0);
    } else {
      setApiKeyList([]);
      setTotalPages(1);
      setTotalDocs(0);
    }
  } catch (err) {
    setApiKeyList([]);
    setTotalPages(1);
    setTotalDocs(0);
  }
  setLoading(false);
};

const handleToggleStatus = async (id) => {
  try {
    const response = await postRequest(`private/apiKeyStatus/${id}`, {}, authCtx.token);
    if (response?.status === 200) {
      Swal.fire('Success', response?.message || 'Status updated', 'success');
      fetchApiKeys(searchName, page); 
    } else {
      Swal.fire('Error', response?.message || 'Something went wrong', 'error');
    }
  } catch (error) {
    Swal.fire('Error', 'Something went wrong', 'error');
  }
};

const handleDeleteApiKey = async (id) => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this API Key!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#bb0000',
    cancelButtonColor: '#aaa',
    confirmButtonText: 'Yes, delete it!',
  });

  if (result.isConfirmed) {
    try {
      const response = await postRequest(`private/deleteApiKey/${id}`, {}, authCtx.token);
      if (response?.status === 200) {
        Swal.fire('Deleted!', 'API Key has been deleted.', 'success');
        
        // Adjust page if last item deleted
        const isLastItemOnPage = apiKeyList.length === 1 && page > 1;
        fetchApiKeys(searchName, isLastItemOnPage ? page - 1 : page);
      } else {
        Swal.fire('Failed!', response?.message || 'Something went wrong.', 'error');
      }
    } catch (err) {
      Swal.fire('Error!', err?.message || 'Something went wrong.', 'error');
    }
  }
};



  // Fetch on mount and when page changes
  useEffect(() => {
    fetchApiKeys(searchName, page);
    // eslint-disable-next-line
  }, [page, authCtx.token]);

  // Debounced search on name or postcode change
  useEffect(() => {
    setPage(1); // Reset to first page on search
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchApiKeys(searchName, 1);
    }, 400);
    // eslint-disable-next-line
  }, [searchName]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };




  // Check if user has any API permissions
  if (!canCreateAPIKeys && !canDisableAPIKeys) {
    return (
      <>
        <BreadcrumbsWrapper
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'API Keys', path: '' },
          ]}
        />
        <br></br>
        <div className='page-header pb-3'>
          <h1 className='mt-0 mb-0'>API Keys</h1>
        </div>
        <div className='page-top-formview mb-3 text-center'>
          <Typography variant="h6" color="text.secondary">
            You do not have permission to manage API keys.
          </Typography>
        </div>
      </>
    );
  }

  return (
    <>
         <BreadcrumbsWrapper
                                            items={[
                                              { label: 'Dashboard', path: '/dashboard' },
                                              { label: 'ApiKeys', path: '' },
                                            
                                             
                                            ]}
                                          />
                                    <br></br>
      <div className='page-header'>
        <h1 className='mt-0'>Api Keys</h1>
        {canCreateAPIKeys && (
          <div className='header-right-btn'>
            <Stack spacing={2} direction="row">
              <Button variant="outlined" className='red-outline-btn text-capitalize'>
                <NavLink to="/apiKey/create" className="red-link-text">
                  <PersonAddOutlinedIcon /> &nbsp; Add New Api Key
                </NavLink>
              </Button>
            </Stack>
          </div>
        )}
      </div>
      <div className='page-top-formview mb-3'>
        <Form>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="searchUsername">
              <Form.Label>Api Key Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Search with title"
                value={searchName}
                onChange={e => {
                  setSearchName(e.target.value);
                  setPage(1);
                }}
              />
            </Form.Group>
          </Row>
        </Form>
      </div>

      <div>
        <Table striped responsive bordered>
          <thead>
            <tr>
             
              <th>Title</th>
              <th>Key</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  <CircularProgress size={28} />
                </td>
              </tr>
            ) : apiKeyList?.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>
                  No api keys found.
                </td>
              </tr>
            ) : (
              apiKeyList?.map((api) => (
              <tr key={api._id}>
  <td>{api?.name}</td>
 <td>
  {api?.key
    ? api.key.length >= 5
      ? `${api.key.slice(0, 4)}${'*'.repeat(api.key.length - 5)}${api.key.slice(-2)}`
      : '*'.repeat(api.key.length)
    : '-'}
</td>


  <td>
    {canDisableAPIKeys ? (
      <>
        <Switch
          checked={api?.isActive}
          onChange={() => handleToggleStatus(api._id)}
          color="primary"
        />
        {api?.isActive ? "Enabled" : "Disabled"}
      </>
    ) : (
      <span>{api?.isActive ? "Enabled" : "Disabled"}</span>
    )}
  </td>
    <td>
    {/* <span
      className='red-link-text cursor-pointer w-18'
      title="Edit"
      style={{ marginRight: 8 }}
    >
      <NavLink to={`/apiKey/edit/${api._id}`} className="red-link-text">
        <EditOutlinedIcon />
      </NavLink>
    </span> */}
    <span
      className='red-link-text cursor-pointer w-18'
      title="Delete"
      onClick={() => handleDeleteApiKey(api._id)}
    >
      <DeleteOutlineOutlinedIcon />
    </span>
  </td>
</tr>

              ))
            )}
          </tbody>
        </Table>
        {/* Pagination */}
      {apiKeyList.length > 0 && (
  <>
    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 8, marginBottom: 8 }}>
      <span className="text-muted small">
        Showing {((page - 1) * 5) + 1}-{Math.min(page * 5, totalDocs)} of {totalDocs} api keys
      </span>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8 }}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        color="primary"
        shape="rounded"
        size="medium"
        sx={{
                  '& .Mui-selected': {
                    background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important',
                    color: '#fff !important',
                  },
                  '& .MuiPaginationItem-root': {
                    color: 'var(--bs-red-color)',
                    borderColor: 'var(--bs-red-color)',
                  },
                }}
      />
    </div>
  </>
)}

      </div>
    </>
  );
}